import VideoSectionPage from '../components/VideoSectionPage';

const SECTIONS_SEMENCE = [
  { key: 'bySemence', label: 'LA SEMENCE MATINALE PAR ANNÉE', renderKey: 'byYear' },
  { key: 'bySemenceTheme', label: 'LA SEMENCE MATINALE PAR THÈME', renderKey: 'byTheme' },
];

export default function SemencePage() {
  return (
    <VideoSectionPage
      section="semence_matinale"
      sidebarLabel="SEMENCE MATINALE PAR ANNÉE"
      renderKey="byYear"
      videoTitlePrefix="Semence matinale du "
      showThemeFilter={true}
      multipleVideosPerDay={true}
      extraSections={SECTIONS_SEMENCE}
    />
  );
}
